import addCustomMethods from './addCustomMethods';

const initValidation = () => {
  addCustomMethods();
};

export default initValidation;
